import { ChevronLeftIcon } from "./Icons";

// Plain wrapper: the auth page layout (SignUpFlow) supplies the panel
const AuthCard = ({ children }) => (
  <div className="w-full max-w-[420px] mx-auto min-h-[480px] lg:min-h-[540px] flex flex-col justify-center animate-in fade-in duration-200">
    {children}
  </div>
);

export const CardTitle = ({ children, className = "" }) => (
  <h1
    className={`font-geomanistMedium text-[24px] leading-8 text-blackShade mb-1.5 ${className}`}
  >
    {children}
  </h1>
);

export const CardSubtitle = ({ children, className = "" }) => (
  <p
    className={`font-geomanistRegular text-sm leading-5 text-geomanistgray mb-0 ${className}`}
  >
    {children}
  </p>
);

export const IconBadge = ({ children, tone = "blue", className = "" }) => {
  const tones = {
    blue: "bg-[#E6EFFB] text-blueish",
    red: "bg-[#FFE5E9] text-failed",
    green: "bg-[#E3F7EA] text-success",
  };
  return (
    <div
      className={`w-14 h-14 rounded-full flex items-center justify-center ${tones[tone]} ${className}`}
    >
      {children}
    </div>
  );
};

export const TextButton = ({ children, onClick, className = "", disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`bg-transparent border-0 p-0 font-geomanistBold text-sm text-blueish hover:underline disabled:opacity-50 disabled:cursor-not-allowed disabled:no-underline ${className}`}
  >
    {children}
  </button>
);

export const BackLink = ({ label = "Back", onClick }) => (
  <div className="flex justify-center mt-5">
    <button
      type="button"
      onClick={onClick}
      className="bg-transparent border-0 p-0 flex items-center gap-1 font-geomanistRegular text-sm text-geomanistgray hover:text-blackShade"
    >
      <ChevronLeftIcon />
      {label}
    </button>
  </div>
);

export const Notice = ({ children, tone = "gray", icon, className = "" }) => {
  const tones = {
    gray: "bg-[#F7F7F8] text-geomanistgray border-[#F7F7F8]",
    amber: "bg-[#FFF8E6] text-[#8A5A00] border-[#F6E3B0]",
    red: "bg-[#FFF1F3] text-failed border-[#FFD3DA]",
  };
  return (
    <div
      className={`flex items-start gap-2 rounded-lg border px-3 py-2.5 font-geomanistRegular text-xs leading-4 ${tones[tone]} ${className}`}
    >
      {icon && <span className="mt-[1px] shrink-0">{icon}</span>}
      <span>{children}</span>
    </div>
  );
};

export default AuthCard;
